import { useLocation } from "react-router-dom";
import WooProducts from "../components/WooProducts";
import "./Shop.css"; // CSS file import karna na bhoolein

function Shop() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const search = params.get("search") || "";

    return (
        <div className="shop-container">
            <h2 className="shop-title">
                {search ? `Search: ${search}` : "Shop Collection"}
            </h2>
            
            {/* Wrapper for responsiveness */}
            <div className="products-grid-wrapper">
                <WooProducts search={search} />
            </div>
        </div>
    );
}

export default Shop;